// ProductDetailList.js
import { connect } from 'react-redux';
import { LRUCache } from 'lru-cache';

import ProductDetailList from '../component/ProductDetailList.jsx';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import fetchFeeds from '../action/fetchFeeds.js';

import { getFeedNameType } from '../resource/feedUtils.js';
import withSelectSkuId from '../resource/withSelectSkuId.js';

const cache = new LRUCache({ max: 256 });
const getSelectPath = ({ feedName } = {}) => {
  const key = `${feedName}`;
  let result = cache.get(key);
  if (!result) {
    result = ['home', getFeedNameType({ feedName }), feedName];
    cache.set(key, result);
  }
  return result;
};

const mapStateToProps = (state, { feedName }) => {
  const listSelectPath = getSelectPath({ feedName });
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  return {
    feedName,
    listSelectPath,
    messageIds: getListData(state, listSelectPath, 'itemIds'),
    nextPage,
    isNextPageFetching: !!getNetworkingData(
      state,
      [...listSelectPath, nextPage],
      'isFetching'
    ),
    nextPageError: getNetworkingData(
      state,
      [...listSelectPath, nextPage],
      'error'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSelectSkuId(ProductDetailList));
